import { AppBar, Toolbar } from '@material-ui/core';
import { alpha, makeStyles } from '@material-ui/core/styles';
import React from 'react';
// ----------------------------------------------------------------------
const APPBAR_HEIGHT = 56;
const useStyles = makeStyles((theme) => ({
    root: {
        zIndex: (props) => props.zIndex || 999,
        backdropFilter: 'blur(8px)',
        boxShadow: theme.shadows[25].z8,
        color: theme.palette.text.primary,
        backgroundColor: alpha(theme.palette.background.default, 0.72),
        [theme.breakpoints.up('md')]: {
            zIndex: (props) => props.zIndexUpMd || 1999
        }
    },
    toolbar: {
        minHeight: APPBAR_HEIGHT
    }
}));
export const EditorHeader = ({ styles, children }) => {
    const classes = useStyles(styles);
    return (React.createElement(AppBar, { className: classes.root },
        React.createElement(Toolbar, { className: classes.toolbar }, children)));
};
//# sourceMappingURL=index.js.map